import { connect } from 'react-redux';

import Placeholder from 'dashboard/modules/Placeholder';
import { showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';

const GraphModule = () => {
  return <PureGraph />;
};

const mapStateToProps = (state: RootState) => {
  return {
    case: state.case.case,
    currentEnvironment: state.currentEnvironment.currentEnvironment,
    objects: state.case.caseToken ? state.case.case[state.case.caseToken].caseDetails?.objects : [],
  };
};

const mapDispatchToProps = {
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(GraphModule);

const PureGraph = () => {
  const renderGraphCard = () => {
    return <Placeholder title='Graph' message='This module is no longer supported.' />;
  };

  return <div>{renderGraphCard()}</div>;
};
